<script>
    import { Col, Container, Row } from 'sveltestrap'
    import { createEventDispatcher } from 'svelte'
    import { Button } from 'sveltestrap'

    const dispatch = createEventDispatcher()

    let staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'
</script>

<style>
    h1 {
        color: #077175;
    }

    p {
        color: #444444;
        font-size: 1.5em;
    }

    img {
        max-height: 500px;
    }
</style>

<Container class="min-vh-100 h-100">
    <Row class="pt-5">
        <Col xl="5" lg="6" md="12">
            <h1 class="text-center my-5">Welcome!</h1>
            <p class="text-center">Ready to configure your app?</p>
            <p class="text-center">
                Let's walk through the important pieces that come together in creating your app. You can always save and
                continue your progress at any time.
            </p>
        </Col>
        <Col xl="7" lg="6" md="12" class="d-flex justify-content-center">
            <img
                class="d-block img-fluid"
                src="{staticAssetPrefix}img/onboarding/welcome.png"
                alt="welcome to the onboarding portal"
            />
        </Col>
    </Row>

    <Row class="mt-5">
        <Col class="d-flex justify-content-center">
            <Button on:click={() => dispatch('continueClicked', { context: {} })} color="primary">Continue</Button>
        </Col>
    </Row>
</Container>
